import React from 'react'
import { Container } from './styles'
import logoImage from '../../assets/logo-funssest.png'

const Logo: React.FC = () => {
  return <Container src={logoImage} alt="Aspprev" />
}

export default Logo
